export default "__VITE_ASSET__d46c50ef__"